import { IUpdateSettings } from "@/api/AppApi/services/auth/interfaces/IAuth";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { DeliveryMethodsTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import SvgEdit from "@/app/components/common-builder/pop-ups-components/pop-up-helpers/SvgEdit";
import SvgLocation from "@/app/components/common-builder/pop-ups-components/pop-up-helpers/SvgLocation";
import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";

import SvgDelivery from "@/app/components/pages-components/checkout/checkout-icons/SvgDelivery";
import SvgPickup from "@/app/components/pages-components/checkout/checkout-icons/SvgPickup";
import { useTranslation } from "@/hooks/localization/useTranslations";
import {
  getPCAppHorPadding,
  getPCMaxAppWidth,
} from "@/utils/functions/global-constants";
import moment from "moment";
import React from "react";

interface Props {
  top: number;
  handleDrawerOpen: () => void;
  mobile: boolean;
  settings: IUpdateSettings;
}
const DeliveryNavpar: React.FC<Props> = ({
  top,
  handleDrawerOpen,
  mobile,
  settings,
}) => {
  const t = useTranslation();

  const getCompany = useGetCompanyQuery();
  const company = getCompany?.data?.result;
  const isStandardWidth = company?.theme?.components?.body
    ?.layout_standard_width as boolean;

  const { address_name, country_name } = settings?.delivery_address_obj ?? {};
  const {
    delivery_time,
    pickup_time,
    receiving_type,
    pickup_branch_obj,
    delivery_time_type,
    pickup_time_type,
  } = settings ?? {};
  const receivingTime =
    receiving_type === DeliveryMethodsTypes.delivery
      ? delivery_time
      : pickup_time;
  const receivingTimeType =
    receiving_type === DeliveryMethodsTypes.delivery
      ? delivery_time_type
      : pickup_time_type;
  const receivingBranch = pickup_branch_obj?.name;
  return (
    <nav
      className="delivery-header nav-bar w-100 dn-container"
      style={{ position: "fixed", top: top }}
      onClick={handleDrawerOpen}
    >
      <div
        className="d-flex flex-nowrap align-items-center justify-content-between p-0 my-2 w-100 dn-wrapper"
        style={{
          width: getPCMaxAppWidth(isStandardWidth),
          maxWidth: "100%",
          padding: `0 ${getPCAppHorPadding(isStandardWidth)}px`,
          margin: "auto",
          gap: 16,
        }}
      >
        <div className="d-flex dn-content-left" style={{ flex: 1, minWidth: 0 }}>
          {receiving_type && (
            <div
              className={`curr-address w-100 dn-receiving-info ${
                mobile ? "flex-column align-items-start" : "align-items-center"
              }`}
            >
              <div className="address-item text-truncate dn-method-time">
                <span className="d-flex align-items-center justify-content-center flex-shrink-0 dn-icon-method">
                  {receiving_type === DeliveryMethodsTypes.delivery ? (
                    <SvgDelivery mobile={false} primary />
                  ) : (
                    <SvgPickup isPrimaryColor mobile={false} />
                  )}
                </span>
                <div className="text-truncate d-flex align-items-center dn-method-text-wrapper" style={{ gap: "4px" }}>
                  <span className="text-truncate dn-method-label">{t[receiving_type]}</span>
                  <span className="dn-separator">|</span>
                  <span className="text-truncate dn-receiving-time" dir="auto">
                    {receivingTimeType === "now"
                      ? t.now
                      : moment(receivingTime).format("MMM, DD, YYYY hh:mm A")}
                  </span>
                </div>
              </div>
              <div className="address-item text-truncate dn-location-info">
                <span className="d-flex align-items-center justify-content-center flex-shrink-0 dn-icon-location">
                  <SvgLocation />
                </span>
                <div className="text-truncate dn-location-text">
                  {receiving_type === DeliveryMethodsTypes.delivery ? (
                    <>
                      {address_name} ({country_name})
                    </>
                  ) : (
                    <>{receivingBranch}</>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="d-flex flex-shrink-0 dn-action-right">
          <CustomButton
            type={mobile ? BtnTypes.semi_small_no_border : BtnTypes.semi_small}
            size={BtnSizes.semi_small}
            radius={BtnRadius.semi_small}
            onClick={handleDrawerOpen}
            className="dn-edit-button"
          >
            <SvgEdit />
            {!mobile && <div className="dn-change-text" style={{ marginInlineStart: 8 }}>{t.change}</div>}
          </CustomButton>
        </div>
      </div>
    </nav>
  );
};

export default DeliveryNavpar;
